import { appConfig, headerConfig, refineHeader } from '../../config';

export const pageTemplateService = {
	templateList,
	getPageTemplate,
	updateTemplate,
	executeContract,
    saveFooterTemplate,
    getFooterTemplate,
    saveHeaderTemplate,
}

function templateList(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}page-template/list`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function executeContract(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}deal/executeContractByMerchant`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateTemplate(postData) {
    refineHeader();
    const requestOptions = {
        method: 'PUT',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}page-template/update`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getPageTemplate(templateType) {
    refineHeader();
    const requestOptions = {
        method: 'GET',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}page-template/template-type/${templateType}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
            }
 
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
 
        return data;
    });
}

function saveFooterTemplate(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}dynamic-footer/save`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function saveHeaderTemplate(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}dynamic-header/save`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getFooterTemplate(templateType) {
    refineHeader();
    const requestOptions = {
        method: 'GET',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}dynamic-footer/content`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}


// WEBPACK FOOTER //
// ./src/app/services/API/pageTemplateService.js